import {
  CREDITS_FETCH_COMPLETED,
  CREDITS_FETCH_STARTED,
  NETWORK_REQUEST_SENT,
  SEMESTER_GRADE_CREDITS_FETCH_COMPLETED,
  SET_CREDITS_LOADING
} from "./types";
import { BACKEND_URL_PREFIX } from "../utils/const";
import { buildDefaultHeaders } from "./helper";
import { checkAndUpdateToken } from "./auth";
import { createNotification } from "../components/notifications/notifications";

export const gradebook = (studentId, trimestrId) => async (
  dispatch,
  getState
) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: CREDITS_FETCH_STARTED });
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/gradebook/${studentId}/${trimestrId}`,
      buildDefaultHeaders(getState)
    );
    dispatch({ type: NETWORK_REQUEST_SENT, response });
    if (response.ok) {
      const result = await response.json();
      dispatch({ type: CREDITS_FETCH_COMPLETED, gradebook: result });
    }
  }
}
export const getSemesterGrades = (studentId, trimestrId) => async (
  dispatch,
  getState
) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: CREDITS_FETCH_STARTED });
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/interim_certification`,
      buildDefaultHeaders(getState)
    );
    dispatch({ type: NETWORK_REQUEST_SENT, response });
    if (response.ok) {
      const result = await response.json();
      dispatch({ type: SEMESTER_GRADE_CREDITS_FETCH_COMPLETED, semesterGrades: result });
    }
  }
}

export const downloadFile = (mid) => async (dispatch, getState) => {
  dispatch({ type: SET_CREDITS_LOADING, payload: true });
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    try {
      const response = await fetch(`${BACKEND_URL_PREFIX}/report/gradebook/${mid}`, {
        method: 'GET',
        ...buildDefaultHeaders(getState),
      });

      if (!response.ok) {
        const text = await response.text();
        createNotification('error', text || 'Ошибка при скачивании файла');
        return;
      }

      // Получаем бинарные данные как blob
      const blob = await response.blob();

      // Создаем временную ссылку и инициируем загрузку
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `Зачетная книжка.pdf`; // Название файла
      document.body.appendChild(a);
      a.click();
      a.remove();

      window.URL.revokeObjectURL(url); // очистка
      createNotification('success', 'Файл успешно скачан');
    } catch (error) {
      console.error('Ошибка при скачивании файла:', error);
      createNotification('error', 'Ошибка при скачивании файла');
    }
  }
      dispatch({ type: SET_CREDITS_LOADING, payload: false });
};